import React from "react";
import { Gallery as PhotoswipeGallery } from "react-photoswipe-gallery";
import styled, { css } from "styled-components";
import GalleryPicture from "~/components/PictureGallery/GalleryPicture";
import { Picture } from "~/components/PictureGallery/Picture";

const Gallery = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 190px);
  grid-gap: ${({ theme }) => theme.spacing(3)};
`;

const ImageContainer = styled.div`
  display: none;
  position: relative;
  scroll-snap-align: start;
`;

const Image1Container = styled.div<{ numberOfImage: number }>`
  ${({ numberOfImage }) => {
    if (numberOfImage === 1) {
      return css`
        grid-column: 1 / span 4;
        grid-row: 1 / span 2;
      `;
    }

    return css`
      grid-column: 1 / span 2;
      grid-row: 1 / span 2;
    `;
  }}
`;

const Image2Container = styled.div<{ numberOfImage: number }>`
  ${({ numberOfImage }) => {
    if (numberOfImage === 2) {
      return css`
        grid-column: 3 / span 4;
        grid-row: 1 / span 2;
      `;
    }

    if (numberOfImage === 3) {
      return css`
        grid-column: 3 / span 2;
        grid-row: 1 / span 1;
      `;
    }

    return css`
      grid-column: 3 / span 1;
      grid-row: 1 / span 1;
    `;
  }}
`;

const Image3Container = styled.div<{ numberOfImage: number }>`
  ${({ numberOfImage }) => {
    if (numberOfImage === 3) {
      return css`
        grid-column: 3 / span 2;
        grid-row: 2 / span 1;
      `;
    }

    return css`
      grid-column: 3 / span 1;
      grid-row: 2 / span 1;
    `;
  }}
`;

const Image4Container = styled.div<{ numberOfImage: number }>`
  grid-column: 4 / span 1;
  grid-row: 1 / span 2;
`;

type LargePictureGalleryProps = {
  gallery: Array<Picture>;
};

const LargePictureGallery = ({ gallery }: LargePictureGalleryProps) => {
  const numberOfImage = gallery.length;
  const [image1, image2, image3, image4, ...otherPictures] = gallery;

  return (
    <Gallery>
      <PhotoswipeGallery
        options={{
          zoom: false,
          counter: false,
        }}
      >
        <Image1Container numberOfImage={numberOfImage}>
          <GalleryPicture picture={image1} />
        </Image1Container>
        {numberOfImage > 1 ? (
          <Image2Container numberOfImage={numberOfImage}>
            <GalleryPicture picture={image2} />
          </Image2Container>
        ) : undefined}
        {numberOfImage > 2 ? (
          <Image3Container numberOfImage={numberOfImage}>
            <GalleryPicture picture={image3} />
          </Image3Container>
        ) : undefined}
        {numberOfImage > 3 ? (
          <Image4Container numberOfImage={numberOfImage}>
            <GalleryPicture picture={image4} />
          </Image4Container>
        ) : undefined}
        {otherPictures.map((picture, index) => (
          <ImageContainer key={index}>
            <GalleryPicture picture={picture} />
          </ImageContainer>
        ))}
      </PhotoswipeGallery>
    </Gallery>
  );
};

export default LargePictureGallery;
